import Mutations from '../../odata/mutations';

export default { ...new Mutations('xeroAudit'), ...new Mutations('xeroAudits') };
